module.exports = __webpack_public_path__ + "static/media/bellSound.85efe6b6.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/images/bellSound.mp3
// module id = 246
// module chunks = 0